module.exports = __webpack_public_path__ + "img/edge_nature_ile.fc95a41b.svg";